/**
 * Cleaning pricing — UI-only feature flags.
 *
 * Backend dual-path is preserved (subscription create accepts both catalog
 * and custom payloads — decision #32). These flags only control what the
 * ops UI exposes.
 *
 * See: docs/02_Product/feature_specs/CLEANING_SERVICE_FEATURE_MAP.md
 *      §"Pricing UI Policy" for the rationale.
 */

// When false, the wizard and CreateSubscriptionModal hide the custom-pricing
// option (PackageSelector empty entry + listPrice/visits/validityDays panel).
// Catalog-only mode enforces pricing discipline at MVP — discount-on-gross
// (decision #14) handles the common goodwill / negotiated cases without
// abandoning the catalog.
//
// Flip to `true` only if there's a deliberate need to expose ad-hoc pricing
// in the UI (e.g., a future ops-admin override flow, or to support an edge
// tier the catalog doesn't yet cover). Backend will continue to honor any
// custom payload shape regardless of this flag.
export const CUSTOM_PRICING_UI_ENABLED = false;
